<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<label (dragleave)="handleDrag($event)"
       (dragover)="handleDrag($event)"
       (drop)="handleDroppedFile($event)"
       class="file-chooser">
    <input
        #fileInput
        (change)="handleFileInput($event)"
        [accept]="accept"
        type="file"
    />
    <span class="selection">
        {{ config.value ? config.value.name : 'global.input.file.placeholder' | translate }}
    </span>
    <small class="accept">{{ 'global.input.file.accepted' | translate: {accept} }}</small>
</label>
